module.exports = __webpack_public_path__ + "img/07.21fdd4f8.jpg";